<template>
  <div class="w-100">
    <div class="container-fluid px-0">
      <div class="row align-items-center mb-3 mx-0">
        <div class="col-12 col-lg-6 text-left px-0">
          <div
            class="w-100 d-flex align-items-center justify-content-between justify-content-lg-start"
          >
            <span class="carousel_title_new">Radio</span>
          </div>
        </div>
      </div>
      <div
        class="row mx-0 latest-tv-rails-content"
        id="latestRadioPageCarousel"
      >
        <div class="w-100">
          <div class="owl-carousel owl-theme" id="radiopagecarouselv2">
            <div
              class="item"
              v-for="item_radio in radio"
              :key="item_radio.id"
              :class="{ active_id_div: active_id == item_radio.id }"
            >
              <radioCard :image="item_radio.img_link" :id="item_radio.id" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import Vue from "vue";
import radioCard from "../../cards/radioCard.vue";
export default {
  data: function() {
    return {
      radio: [],
    };
  },
  props: ["active_id"],
  components: { radioCard },
  created: function() {
    this.$store.dispatch("fetchRadio", { self: this });
  },
  methods: {
    filterRadio() {
      //for latest video
      var vm = this;

      var radio_order = [4, 7, 6, 3, 5];

      var data = this.$store.state.radio.data;

      data.sort(function(a, b) {
        return radio_order.indexOf(a.id) - radio_order.indexOf(b.id);
      });

      vm.radio = data;

      var store = [];
      vm.radio.forEach((item) => {
        item["img_link"] = this.imgFiltering(item);
        store.push(item);
      });

      vm.radio = store.slice(0, 8);

      Vue.nextTick(
        function() {
          vm.installOwlCarousel("#radiopagecarouselv2");
        }.bind(vm)
      );
    },

    installOwlCarousel: function(carousel) {
      $(carousel).owlCarousel({
        items: 4,
        autoplay: false,
        loop: false,
        nav: false,
        dots: false,
        stagePadding: 0,
        responsiveClass: true,
        navText: [
          '<span class="fa fa-chevron-left fa-md"></span>',
          '<span class="fa fa-chevron-right fa-md"></span>',
        ],
        onInitialize: function(event) {
          if ($(".owl-carousel .item").length <= 1) {
            this.loop = false;
          }
        },
        responsive: {
          0: {
            items: 2,
            nav: false,
            margin: 8,
            stagePadding: 4,
          },
          768: {
            items: 4,
            stagePadding: 0,
            loop: false,
            margin: 16,
            nav: true,
          },
          990: {
            items: 5,
            stagePadding: 0,
            loop: false,
            margin: 16,
            nav: true,
          },
        },
      });
    },

    imgFiltering(item) {
      var imgurl;
      //check if
      var checkThumbnail =
        item.data && item.data.images && item.data.images.thumbnail;
      var checkTitle = item.data && item.data.images && item.data.images.title;
      var checkImgFeature =
        item.data && item.data.images && item.data.images.feature;

      if (checkThumbnail) {
        imgurl =
          "https://rtb-images.glueapi.io/320x0/" +
          item.data.images.thumbnail.path;
      } else {
        if (checkTitle) {
          imgurl =
            "https://rtb-images.glueapi.io/320x0/" +
            item.data.images.title.path;
        } else {
          if (checkImgFeature) {
            imgurl =
              "https://rtb-images.glueapi.io/320x0/" +
              item.data.images.feature.path;
          } else {
            imgurl =
              "https://cdn-rtb.glueapi.io/v1/content/" +
              item.id +
              "/image/300x0/images.title";
          }
        }
      }
      return imgurl;
    },
  },
};
</script>

<style>
.latest-tv-rails-content .owl-theme .owl-stage-outer {
  overflow: unset;
}

#latestRadioPageCarousel .owl-nav {
  display: none;
}

button:focus {
  outline: unset !important;
}

@media only screen and (min-width: 992px) {
  #latestRadioPageCarousel .owl-theme:hover {
    z-index: 111;
  }

  #latestRadioPageCarousel .owl-theme {
    height: auto;
  }
  #latestRadioPageCarousel .owl-item {
    z-index: 1;
  }
  #latestRadioPageCarousel .owl-item:hover {
    transition: 0.1s all ease-in-out;
    width: 100%;
    z-index: 2000;
  }

  #latestRadioPageCarousel .owl-theme .owl-nav.disabled {
    display: none !important;
  }
  #latestRadioPageCarousel .owl-theme .owl-nav {
    position: absolute;
    top: -64px;
    right: 2px;
    width: 80px;
    display: flex;
    justify-content: space-between;
    z-index: 11;
  }

  #latestRadioPageCarousel .owl-prev {
    width: 40px !important;
    height: 36px !important;
    background-color: #fab913;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 8px 0 0;
    z-index: 1;
  }

  #latestRadioPageCarousel .owl-next {
    width: 40px !important;
    height: 36px !important;
    background-color: #fab913;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0;
    z-index: 1;
  }

  #latestRadioPageCarousel .owl-next span,
  #latestRadioPageCarousel .owl-prev span {
    color: rgb(0, 0, 0) !important;
  }
}
</style>

<style scoped>
.carousel_title_new {
  font-family: "Inter", sans-serif;
  font-weight: 700;
  font-size: 24px;
  line-height: 30px;
  color: rgba(250, 185, 19, 1);
}
.view-all-wrapper {
  border-radius: 8px;
  background: rgba(250, 185, 19, 1);
  padding: 6px 12px;
}
.see-more-text {
  font-family: "Poppins", sans-serif !important;
  font-weight: 700;
  font-size: 16px;
  line-height: 30px;
  letter-spacing: 0%;
  color: rgba(0, 0, 0, 1);
}

@media only screen and (max-width: 768px) {
  .carousel_title_new {
    font-size: 18px;
    line-height: 22px;
  }
  .see-more-text {
    font-size: 14px;
    line-height: 22px;
  }
}
</style>
